import { Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

const ModalSectionTitle = ({ children }: PropsWithChildren) => {
  return (
    <Typography
      variant='h6'
      component='h3'
    >
      {children}
    </Typography>
  );
};

export default ModalSectionTitle;
